import { useNavigation } from "@react-navigation/native";
import { APIData } from "../constants";
import useRest from "./base/useRest";

// CONTACTS

const preffix = "accounts";

export const useAccount = (options?: APIData) => {
  return useRest(`${preffix}/`, options);
};


/* Account by type starts */
// -> assets
export const useAccountOfType_bank = (options?: APIData) => {
  return useRest(`${preffix}/type/bank`, options);
};

export const useAccountOfType_payment_clearing = (options?: APIData) => {
  return useRest(`${preffix}/type/payment-clearing`, options);
};

export const useAccountOfType_petty_cash = (options?: APIData) => {
  return useRest(`${preffix}/type/petty-cash`, options);
};

export const useAccountOfType_stock = (options?: APIData) => {
  return useRest(`${preffix}/type/stock`, options);
};

export const useAccountOfType_fixed_asset = (options?: APIData) => {
  return useRest(`${preffix}/type/fixed-asset`, options);
};

export const useAccountOfType_other_asset = (options?: APIData) => {
  return useRest(`${preffix}/type/other-asset`, options);
};

export const useAccountOfType_other_current_asset = (options?: APIData) => {
  return useRest(`${preffix}/type/other-current-asset`, options);
};

// -> liabilities
export const useAccountOfType_credit_card = (options?: APIData) => {
  return useRest(`${preffix}/type/credit-card`, options);
};

export const useAccountOfType_other_liability = (options?: APIData) => {
  return useRest(`${preffix}/type/other-liability`, options);
};

export const useAccountOfType_long_term_liability = (options?: APIData) => {
  return useRest(`${preffix}/type/long-term-liability`, options);
};

// -> equities
export const useAccountOfType_equity = (options?: APIData) => {
  return useRest(`${preffix}/type/equity`, options);
};

// -> incomes
export const useAccountOfType_other_income = (options?: APIData) => {
  return useRest(`${preffix}/type/other-income`, options);
};

export const useAccountOfType_sales = (options?: APIData) => {
  return useRest(`${preffix}/type/sales`, options);
};

// -> expenses
export const useAccountOfType_expense = (options?: APIData) => {
  return useRest(`${preffix}/type/expense`, options);
};


export const useAccountOfType_direct_cost = (options?: APIData) => {
  return useRest(`${preffix}/type/direct-cost`, options);
}

export const useAccountOfType_depreciation = (options?: APIData) => {
  return useRest(`${preffix}/type/depreciation`, options);
};

export const useAccountOfType_other_expense = (options?: APIData) => {
  return useRest(`${preffix}/type/other-expense`, options);
};




/* Account by key starts */
export const useInvenrotyAccount = (options?: APIData) => {
  return useRest(`${preffix}/key/stock-of-merchandises-acct`, options);
};

export const useSaleAccount = (options?: APIData) => {
  return useRest(`${preffix}/key/sales-acct`, options);
};


export const useCogsAccount = (options?: APIData) => {
  return useRest(`${preffix}/key/cost-of-goods-sold-acct`, options);
};

export const usePurchaseAccount = (options?: APIData) => {
  return useRest(`${preffix}/key/purchases-acct`, options);
};
